import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
// import { Card, CardActionArea, CardMedia } from '@material-ui/core';
import Grid from "@material-ui/core/Grid";
import SaveIcon from "@material-ui/icons/Save";
// import { Delete, CloseOutlined } from "@material-ui/icons/";
import { Formik, Form, yupToFormErrors } from "formik";
import * as Yup from "yup";
// import ModalFrame from "../../biztran_controls/Modal_Frame";
import Moment from "moment";
// import CreateMultipleDates from "./CreateMultipleDates"
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";


const CreateMultipleDates = (props) => {

  const classes = useStyles();
  const [response, fetchData] = UseFetchData();
  const [isOpen, setOpen] = useState(false);
  // const [isTwoopen, setisTwoopen] = useState(false);
  const [Mode, setMode] = useState('');
  // const [ProductSKUID,setProductSKUID] = useState('');
  const [RemainQuantity, setRemainQuantity] = useState('');
  const [Quantity, setQuantity] = useState([]);
  const [DeliveryDate, setDeliveryDate] = useState([]);
  const [ModelCode, setModelCode] = useState("");
  const [Seq, setSeq] = useState("");
  const [StateName, setStateName] = useState();
  const [Description, setDescription] = useState('');
  const [Rate, setRate] = useState(0);
  const [CgstAmt, setCgstAmt] = useState();
  const [count, setcount] = useState(0);
  const [SgstAmt, setSgstAmt] = useState();
  const [IgstAmt, setIgstAmt] = useState();
  // const [GstPer, setGstPer] = useState();
  const [TotalQuantity, setTotalQuantity] = useState("");
  const [CgstPer, setCgstPer] = useState();
  const [SgstPer, setSgstPer] = useState();
  const [IgstPer, setIgstPer] = useState();
  const [DiscountPer, setDiscountPer] = useState();
  const [DiscountAmt, setDiscountAmt] = useState();
  const [Total, setTotal] = useState();
  const [SalesOrderDtlsID, setSalesOrderDtlsID] = useState();
  const [Productresponse, FetchProduct] = UseFetchData();
  const [DisableIgstPer, setDisableIgstPer] = useState(false);
  const [DisableTotalQuantity, setDisableTotalQuantity] = useState(false);
  const [DisableCgstPer, setDisableCgstPer] = useState(false);
  // const [DisableCgstAmt, setDisableCgstAmt] = useState(false);
  const [DisableSgstPer, setDisableSgstPer] = useState(false);
  const [rows, setRows] = useState([]);
  const [btn, setBtn] = useState(false);

  const validationSchema = Yup.object({
    // Quantity: Yup.number().required("Required!"),
    // DeliveryDate: Yup.date().required("Required!")
  });


  const handleChange = (idx) => (e) => {
    // debugger;
    const { name, value } = e.target;
    const rowData = [...rows];
    rowData[idx] = {
      [name]: value
    };
    setRows(rowData);
    if (e.target.name === "DeliveryDate") {
      if ((idx + 1) > DeliveryDate.length) {
        const delArr = DeliveryDate;
        setDeliveryDate([...delArr, e.target.value]);
      }
      else {
        const delArr = DeliveryDate;
        delArr[idx] = e.target.value;
        setDeliveryDate(delArr)
      }
    }
    if (e.target.name === "Quantity") {
      if ((idx + 1) > Quantity.length) {
        const qtyArr = Quantity;
        setQuantity([...qtyArr, e.target.value]);

        setTotalQuantity(TotalQuantity - e.target.value);
      }
      else {
        const qtyArr = Quantity;
        qtyArr[idx] = e.target.value;
        setQuantity(qtyArr)
      }
    }
    if (TotalQuantity < 2) {
      setBtn(true);
    }
  };

  const handleAddRow = () => {
    const item = {
      DeliveryDate: "",
      Quantity: ""
    };
    setRows([...rows, item]);
    console.log(rows.length);
    setcount(rows.length);
  };
  const handleRemoveRow = () => {
    setRows(rows.slice(0, -1));
  };


  const onSub = () => {
    // debugger;
    for (var i = 0; i < DeliveryDate.length; i++) {
      var bodyFormData = new FormData();
      bodyFormData.append("SalesOrderDtlsID", props.SalesOrderDtlsID);
      bodyFormData.append("SalesOrderID", props.SOID);
      bodyFormData.append("Seq", Seq);
      bodyFormData.append("ProductSKUID", props.ProductSKUID);
      bodyFormData.append("Description", Description);
      bodyFormData.append("Quantity", parseInt(Quantity[i]));
      bodyFormData.append("Rate", parseInt(Rate));
      bodyFormData.append("DiscountPer", parseInt(DiscountPer));
      bodyFormData.append("DiscountAmt", parseInt(DiscountAmt));
      bodyFormData.append("CurrencyID", "");
      bodyFormData.append("ConvFactor", "0");
      bodyFormData.append("TotalQuantity", TotalQuantity);
      bodyFormData.append("DeliveryDate", DeliveryDate[i]);
      bodyFormData.append("CgstPer", parseInt(CgstPer));
      bodyFormData.append("CgstAmt", parseInt(CgstAmt));
      bodyFormData.append("SgstPer", parseInt(SgstPer));
      bodyFormData.append("SgstAmt", parseInt(SgstAmt));
      bodyFormData.append("IgstPer", parseInt(IgstPer));
      bodyFormData.append("IgstAmt", parseInt(IgstAmt));
      bodyFormData.append("TotalAmount", Total);
      fetchData("SalesOrder/AddSlot", bodyFormData);
    }
  };


  useEffect(() => {
    if (response.Response === true) {
      alert("Data Saved Succesfully.");
      props.setOpen(false);
      // props.setisTwoopen(false);
      props.getByIDData();
    } else if (response.Response === false) {
      if (response.Message.includes("Already") === true) {
        alert(response.Message);
      } else {
        alert("Failed.");
      }
    }
  }, [response]);


  const PopulateData = () => {
    var bodyFormData = new FormData();
    // debugger;
    bodyFormData.append("SalesOrderDtlsID", props.SalesOrderDtlsID);
    FetchProduct("SalesOrder/SalesOrderDtlsByID", bodyFormData);
  };

  useEffect(() => {
    PopulateData();
    // updateState();
    setTotalQuantity(props.Quantity);

  }, []);



  useEffect(() => {
    // debugger;
    if (Productresponse.length > 0) {
      setModelCode(Productresponse[0].ModelCode);
      setSeq(Productresponse[0].Seq);
      setDescription(Productresponse[0].Description);
      setRate(Productresponse[0].Rate);
      setDiscountPer(Productresponse[0].DiscountPer);
      setDiscountAmt(Productresponse[0].DiscountAmt);
      setTotal(Productresponse[0].TotalAmount);
      setCgstPer(Productresponse[0].CgstPer);
      setSgstPer(Productresponse[0].SgstPer);
      setIgstPer(Productresponse[0].IgstPer);
      setCgstAmt(Productresponse[0].CgstAmt);
      setSgstAmt(Productresponse[0].SgstAmt);
      setIgstAmt(Productresponse[0].IgstAmt);
      // setTotalQuantity(Productresponse[0].TotalQuantity);
      setStateName(Productresponse[0].StateName);
      if (Productresponse[0].StateName === "Maharashtra") {
        setDisableIgstPer(true);
        setIgstPer(0);
        setIgstAmt(0);
      }
      else {
        setDisableCgstPer(true);
        setCgstPer(0);
        setCgstAmt(0);
        setDisableSgstPer(true);
        setSgstAmt(0);
        setSgstPer(0);
      }

    }
  }, [Productresponse]);


  useEffect(() => {
    // debugger;
    const GST = CgstPer / 100;
    const GSTAmt = Rate * GST;
    const FinalRate = (Number(Rate) + Number(GSTAmt)).toFixed(2);
    const FinalAmount = FinalRate * Quantity;
    setCgstAmt(GSTAmt.toFixed(2));

    const GST1 = SgstPer / 100;
    const GSTAmt1 = Rate * GST1;
    const FinalAmount1 = FinalRate * Quantity;
    setSgstAmt(GSTAmt1.toFixed(2));


    const GST2 = IgstPer / 100;
    const GSTAmt2 = Rate * GST2;
    const FinalAmount2 = FinalRate * Quantity;
    setIgstAmt(GSTAmt2.toFixed(2));


    // setAmount(Quantity * Rate);
    // debugger;
    // setTotal(((Quantity * Rate) + ((IgstPer + CgstPer + SgstPer) / 100) * Rate * Quantity - DiscountAmt * Quantity).toFixed(2));
    setTotal(((Quantity * Rate) + ((GSTAmt2 + GSTAmt1 + GSTAmt) * Quantity) - DiscountAmt * Quantity).toFixed(2));

  }, [Rate, Quantity, CgstPer, IgstPer, SgstPer, DiscountPer, DiscountAmt]);

  return (
    <div>
      <Formik
        initialValues={{
          TotalQuantity: TotalQuantity,
          Quantity: Quantity,
          DeliveryDate: DeliveryDate,
          Description: Description,
          Seq: Seq,
          CgstAmt: CgstAmt,
          SgstAmt: SgstAmt,
          IgstAmt: IgstAmt,
          IgstPer: IgstPer,
          SgstPer: SgstPer,
          CgstPer: CgstPer,
          ModelCode: ModelCode,
          Rate: Rate,
          DiscountPer: DiscountPer,
          DiscountAmt: DiscountAmt
        }}
        validationSchema={validationSchema}
        // onSubmit={onSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form>
              {/* <Typography className={classes.headertext} noWrap>Add Product</Typography> */}
              <Grid spacing={1} container direction="row" >
                <Grid spacing={1} item xs={8} container>
                  <Grid item xs={6}>
                    <BiztranControlsFormik
                      control="input"
                      type="text"
                      label="Total Quantity Order"
                      name="TotalQuantity"
                      value={TotalQuantity}
                      disabled
                    // onChange={(e) => setTotalQuantity(e.target.value)}
                    />
                  </Grid>

                </Grid>
              </Grid>
              <div>
                <div className="container">
                  <div className="row clearfix">
                    <div className="col-md-12 column">
                      <table
                        className="table table-bordered table-hover"
                        id="tab_logic"
                      >
                        <thead>
                          <tr>
                            <th className="text-center"> # </th>
                            <th className="text-center"> Delivery Date </th>
                            <th className="text-center"> Quantity </th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((item, idx) => (
                            <tr id="addr0" key={idx}>
                              <td>{idx + 1}</td>
                              <td>
                                <BiztranControlsFormik
                                  control="input"
                                  type="date"
                                  name="DeliveryDate"
                                  value={rows[idx].deliveryDate}
                                  onChange={

                                    handleChange(idx)
                                  }
                                  className="form-control"
                                />
                              </td>
                              <td>
                                <BiztranControlsFormik
                                  control="input"
                                  type="text"
                                  name="Quantity"
                                  value={rows[idx].quantity}
                                  onChange={
                                    handleChange(idx)
                                  }
                                  className="form-control"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <BiztranControls.Button
                        onClick={handleAddRow}
                        disabled={btn}
                        className="btn btn-default pull-left"
                        // startIcon={<PluseIcon />}
                        text="Add Date" />
                      <BiztranControls.Button
                        onClick={handleRemoveRow}
                        className="pull-right btn btn-default"
                        text="Delete  Date"
                      />

                    </div>
                  </div>
                </div>
              </div>
              <Grid spacing={2} container direction="row">
                <Grid item xs={12}>
                  <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                      <BiztranControls.Button
                        text="Updates"
                        type="submit"
                        onClick={() => {
                          onSub();
                        }}
                        startIcon={<SaveIcon />}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Form>
          );

        }}
      </Formik>
    </div>
  );

};

const useStyles = makeStyles((theme) => ({
  headertext: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    paddingLeft: "30px",
    fontSize: "1.5rem",
    marginTop: "-16px",
    marginBottom: "10px",
    marginLeft: "-24px",
    marginRight: "-24px",
    //   borderRadius: "1rem",
  },
  root: {
    height: '100%',
    width: '100%',
    paddingTop: '7%',
    //paddingTop: '56.25%', // 16:9
  },
}
));

export default CreateMultipleDates;